import { createReducer, on } from '@ngrx/store'
import { appProgressbarClose, appProgressbarStart, appProgressbarUpdate } from '../../models/interfaces/app-progressbar-state.interface'
import * as BudgetActions from './budget.actions'
import { initialBudgetState } from './budget.state'

export const budgetReducer = createReducer(
   initialBudgetState,
   on(BudgetActions.exportStaffEffort, BudgetActions.exportPpsForms, BudgetActions.exportWpWeight, BudgetActions.exportCostsJustif, (state) => ({
      ...state,
      exportProgress: appProgressbarStart()
   })),
   on(
      BudgetActions.exportStaffEffortSuccess,
      BudgetActions.exportPpsFormsSuccess,
      BudgetActions.exportWpWeightSuccess,
      BudgetActions.exportCostsJustifSuccess,
      (state, { response }) => ({
         ...state,
         exportProgress: appProgressbarUpdate(state.exportProgress || appProgressbarStart(), response)
      })
   ),
   on(
      BudgetActions.exportStaffEffortFailed,
      BudgetActions.exportPpsFormsFailed,
      BudgetActions.exportWpWeightFailed,
      BudgetActions.exportCostsJustifFailed,
      (state) => ({ ...state, exportProgress: appProgressbarClose('error') })
   ),
   on(BudgetActions.closeExportProgress, (state) => ({ ...state, exportProgress: undefined })),

   on(BudgetActions.loadSalary, (state) => ({ ...state, salary: undefined, isLoadingSalary: true })),
   on(BudgetActions.loadSalarySuccess, (state, { response }) => ({ ...state, salary: response, isLoadingSalary: undefined })),
   on(BudgetActions.loadSalaryFailed, (state) => ({ ...state, isLoadingSalary: undefined })),
   on(BudgetActions.updateSalary, (state) => ({ ...state, isLoadingSalary: true })),
   on(BudgetActions.updateSalarySuccess, (state, { response }) => ({ ...state, salary: response, isLoadingSalary: undefined })),
   on(BudgetActions.updateSalaryFailed, (state) => ({ ...state, isLoadingSalary: undefined })),
   on(BudgetActions.clearSalary, (state) => ({ ...state, salary: undefined, isLoadingSalary: undefined })),

   on(BudgetActions.loadEffort, (state) => ({ ...state, effort: undefined, isLoadingEffort: true })),
   on(BudgetActions.loadEffortSuccess, (state, { response }) => ({ ...state, effort: response, isLoadingEffort: undefined })),
   on(BudgetActions.loadEffortFailed, (state) => ({ ...state, isLoadingEffort: undefined })),
   on(BudgetActions.updateEffort, (state) => ({ ...state, isLoadingEffort: true })),
   on(BudgetActions.updateEffortSuccess, (state, { response }) => ({ ...state, effort: response, isLoadingEffort: undefined })),
   on(BudgetActions.updateEffortFailed, (state) => ({ ...state, isLoadingEffort: undefined })),
   on(BudgetActions.clearEffort, (state) => ({ ...state, effort: undefined, isLoadingEffort: undefined })),

   on(BudgetActions.loadIncome, (state) => ({ ...state, income: undefined, isLoadingIncome: true })),
   on(BudgetActions.loadIncomeSuccess, (state, { response }) => ({ ...state, income: response, isLoadingIncome: undefined })),
   on(BudgetActions.loadIncomeFailed, (state) => ({ ...state, isLoadingIncome: undefined })),
   on(BudgetActions.updateIncome, (state) => ({ ...state, isLoadingIncome: true })),
   on(BudgetActions.updateIncomeSuccess, (state, { response }) => ({ ...state, income: response, isLoadingIncome: undefined })),
   on(BudgetActions.updateIncomeFailed, (state) => ({ ...state, isLoadingIncome: undefined })),
   on(BudgetActions.clearIncome, (state) => ({ ...state, income: undefined, isLoadingIncome: undefined })),

   on(BudgetActions.loadStaffEffort, (state) => ({ ...state, staffEffort: undefined, isLoadingStaffEffort: true })),
   on(BudgetActions.loadStaffEffortSuccess, (state, { response }) => ({ ...state, staffEffort: response, isLoadingStaffEffort: undefined })),
   on(BudgetActions.loadStaffEffortFailed, (state) => ({ ...state, isLoadingStaffEffort: undefined })),
   on(BudgetActions.clearStaffEffort, (state) => ({ ...state, staffEffort: undefined, isLoadingStaffEffort: undefined })),

   on(BudgetActions.loadWpWeight, (state) => ({ ...state, wpWeight: undefined, isLoadingWpWeight: true })),
   on(BudgetActions.loadWpWeightSuccess, (state, { response }) => ({ ...state, wpWeight: response, isLoadingWpWeight: undefined })),
   on(BudgetActions.loadWpWeightFailed, (state) => ({ ...state, isLoadingWpWeight: undefined })),
   on(BudgetActions.clearWpWeight, (state) => ({ ...state, wpWeight: undefined, isLoadingWpWeight: undefined })),

   on(BudgetActions.loadWorkPackage, (state) => ({ ...state, workPackages: undefined, isLoadingWorkPackages: true })),
   on(BudgetActions.loadWorkPackageSuccess, (state, { response }) => ({ ...state, workPackages: response, isLoadingWorkPackages: undefined })),
   on(BudgetActions.loadWorkPackageFailed, (state) => ({ ...state, isLoadingWorkPackages: undefined })),
   on(BudgetActions.clearWorkPackage, (state) => ({ ...state, workPackages: undefined, isLoadingWorkPackages: undefined })),

   on(BudgetActions.loadCostsWp, (state) => ({ ...state, costsPerWp: undefined, isLoadingCostsPerWp: true })),
   on(BudgetActions.loadCostsWpSuccess, (state, { response }) => ({ ...state, costsPerWp: response, isLoadingCostsPerWp: undefined })),
   on(BudgetActions.loadCostsWpFailed, (state) => ({ ...state, isLoadingCostsPerWp: undefined })),
   on(BudgetActions.updateCostsWp, (state) => ({ ...state, isLoadingCostsPerWp: true })),
   on(BudgetActions.updateCostsWpSuccess, (state, { response }) => ({ ...state, costsPerWp: response, isLoadingCostsPerWp: undefined })),
   on(BudgetActions.updateCostsWpFailed, (state) => ({ ...state, isLoadingCostsPerWp: undefined })),
   on(BudgetActions.clearCostsWp, (state) => ({ ...state, costsPerWp: undefined, isLoadingCostsPerWp: undefined })),

   on(BudgetActions.loadPartner, (state) => ({ ...state, partners: undefined, isLoadingPartners: true })),
   on(BudgetActions.loadPartnerSuccess, (state, { response }) => ({ ...state, partners: response, isLoadingPartners: undefined })),
   on(BudgetActions.loadPartnerFailed, (state) => ({ ...state, isLoadingPartners: undefined })),
   on(BudgetActions.updatePartnerStatus, (state) => ({ ...state, isLoadingPartners: true })),
   on(BudgetActions.updatePartnerStatusSuccess, (state) => ({ ...state, isLoadingPartners: undefined })),
   on(BudgetActions.updatePartnerStatusFailed, (state) => ({ ...state, isLoadingPartners: undefined })),
   on(BudgetActions.clearPartner, (state) => ({ ...state, partners: undefined, isLoadingPartners: undefined })),

   on(BudgetActions.loadBudgetJustificationOfCosts, (state) => ({
      ...state,
      justificationOfCosts: undefined,
      isLoadingJustificationOfCosts: true
   })),
   on(BudgetActions.loadBudgetJustificationOfCostsSuccess, (state, { response }) => ({
      ...state,
      justificationOfCosts: response,
      isLoadingJustificationOfCosts: undefined
   })),
   on(BudgetActions.loadBudgetJustificationOfCostsFailed, (state) => ({
      ...state,
      isLoadingJustificationOfCosts: undefined
   })),
   on(BudgetActions.updateBudgetJustificationOfCosts, (state) => ({ ...state, isLoadingJustificationOfCosts: true })),
   on(BudgetActions.updateBudgetJustificationOfCostsSuccess, (state) => ({ ...state, isLoadingJustificationOfCosts: undefined })),
   on(BudgetActions.updateBudgetJustificationOfCostsFailed, (state) => ({ ...state, isLoadingJustificationOfCosts: undefined })),
   on(BudgetActions.clearCostsJustif, (state) => ({ ...state, justificationOfCosts: undefined, isLoadingJustificationOfCosts: undefined })),

   on(BudgetActions.loadBudgetCategoryDOtherCosts, (state) => ({
      ...state,
      categoryDOtherCosts: undefined,
      isLoadingCategoryDOtherCosts: true
   })),
   on(BudgetActions.loadBudgetCategoryDOtherCostsSuccess, (state, { response }) => ({
      ...state,
      categoryDOtherCosts: response,
      isLoadingCategoryDOtherCosts: undefined
   })),
   on(BudgetActions.loadBudgetCategoryDOtherCostsFailed, (state) => ({
      ...state,
      isLoadingCategoryDOtherCosts: undefined
   })),
   on(BudgetActions.putBudgetCategoryDOtherCosts, (state) => ({ ...state, isLoadingCategoryDOtherCosts: true })),
   on(BudgetActions.putBudgetCategoryDOtherCostsSuccess, (state) => ({ ...state, isLoadingCategoryDOtherCosts: undefined })),
   on(BudgetActions.putBudgetCategoryDOtherCostsFailed, (state) => ({ ...state, isLoadingCategoryDOtherCosts: undefined }))
)
